import Checkbox from '@jimmyboys/liita-ui/dist/components/Checkbox'
import React from 'react'
import { useController } from 'react-hook-form'

const HFCheckbox = (props) => {
	const { name, ...attributes } = props
	const {
		field: { ref, value, ...field },
	} = useController({ name })

	return <Checkbox {...attributes} checked={value || false} {...field} />
}

export default HFCheckbox
